import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import CurrentUserProvider from './contexts/CurrentUser';
import SearchProvider from './contexts/Search';
import Forums from './pages/Forums';
import ForumPage from './pages/Forum';
import Post from './pages/Post';
import Topic from './pages/Topic';
import SearchPage from './pages/Search';
import Home from './pages/Home';
import Navigation from './components/Navigation';
import { ROUTES } from './utils/navigation';

import './styles/fonts.css'
import './styles.scss';

function App() {
  const location = useLocation();
  useEffect(() => {
    const routeClass = (location.pathname.split('/')[1] || 'home') + '-route';
    document.body.classList.add(routeClass);
    return () => {
      document.body.classList.remove(routeClass);
    };
  }, [location]);


  return (
    <CurrentUserProvider>
      <SearchProvider>
        <Navigation/>
        <Routes>
          <Route path={ROUTES.HOME} element={<Home/>}/>
          <Route path={ROUTES.SEARCH} element={<SearchPage/>}/>
          <Route path={ROUTES.LIST_FORUMS} element={<Forums/>}/>
          <Route path={ROUTES.FORUM_TOPICS} element={<ForumPage/>}/>
          <Route path={ROUTES.TOPIC_SETS} element={<Topic/>}/>
          <Route path={ROUTES.POST} element={<Post/>} />
        </Routes>
      </SearchProvider>
    </CurrentUserProvider>
  );
}

function AppRouter() {
  return (
    <Router>
      <App/>
    </Router>
  )
}

export default AppRouter;
